<div class="box ml-2">
  <div class="box-header">


  </div>

  <!-- add user -->
  <div class="flex-align-center py-2 px-3" >
    @if (userAction==='dc-user-add') {
      <span class="font-weight-bold title-lg">{{'Add User' | translate}}</span>
    }

    @if (userAction==='dc-user-edit') {
      <span class="font-weight-bold title-lg">{{'Edit User' | translate}}</span>
    }
    @if (userAction==='profile') {
      <span class="font-weight-bold title-lg">{{'My Profile' | translate}}</span>
    }
    @if (userAction!=='profile') {
      <button mat-stroked-button class="ml-auto" (click)="backToSummary()">
        <mat-icon>groups</mat-icon>
        {{'Back to User List' | translate}}
      </button>
    }

    @if (userAction==='profile') {
      <button mat-stroked-button class="ml-auto" (click)="exitProfile()">
        <mat-icon>groups</mat-icon>
        {{'Exit Profile' | translate}}
      </button>
    }
  </div>
  <div class="box-body" >
    <form [formGroup]="dcUserForm">
      <div class="col form col-md-8">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{'First Name' | translate}}</mat-label>
              <input matInput specialCharctersRestrict maxlength="50" formControlName="firstName" required [errorStateMatcher]="nameErrorMatcher" formcon/>
              <mat-error>
                @if (dcUserForm.get('firstName').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{'Last Name' | translate}}</mat-label>
              <input maxlength="50" specialCharctersRestrict formControlName="lastName" matInput required [errorStateMatcher]="nameErrorMatcher" />
              <mat-error>
                @if (dcUserForm.get('lastName').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{'Initials (optional)' | translate}}</mat-label>
              <input matInput type="text" maxlength="50" specialCharactersRestrictAllowEmpty formControlName="intials" [errorStateMatcher]="nameErrorMatcher" />
              <mat-error>
                @if (dcUserForm.get('intials').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">

          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'User ID' | translate}}</mat-label>
              <input matInput   required maxlength="100" emailRestrict formControlName="upn"/>
              <mat-error>
                @if (dcUserForm.get('upn').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'DC Location' | translate}}</mat-label>
              <mat-select required  formControlName="dcLocation"  disableOptionCentering (selectionChange)="getRoleByDC($event)" >
                @for (dc of dcNumbers; track dc) {
                  <mat-option [value]="dc.dcNumber" >
                    {{ dc.dcLocation }} - {{dc.dcName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Province'  | translate}}</mat-label>
              <!-- <input matInput required maxlength="2" minlength="2" formControlName="province"/>
            </mat-form-field> -->
            <mat-select required  formControlName="province" required maxlength="2" minlength="2" disableOptionCentering>
              @for (prov of provinces; track prov) {
                <mat-option [value]="prov" >
                  {{ prov }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">

        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{'User Role' | translate}}</mat-label>
            <mat-select required  formControlName="roleId"  disableOptionCentering>
              @for (role of userRoles; track role) {
                <mat-option [value]="role.roleIdAccess" >
                  {{ role.roleName | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
        <div class="col">


          <div >
            {{'Language' | translate}} *
            <div class="my-2">

              <mat-radio-group formControlName="language">
                <mat-radio-button value="EN">{{'English' | translate}}</mat-radio-button>
                <mat-radio-button value="FR" class="mx-2">{{'French' | translate}}</mat-radio-button>
              </mat-radio-group>

            </div>
          </div>

        </div>

        @if (!isHidden) {
          <div class="col">
            <mat-label>{{'User Status' | translate}} *</mat-label>
            <div class="my-2">
              <mat-slide-toggle formControlName="userStatus"
                class="example-margin"
                (change)="setUserStatus($event)" >{{statusString | translate}}
              </mat-slide-toggle>
            </div>
          </div>
        }


      </div>
      <div class="row form-group flex-align-center">


        <div class="col text-right">
          <button mat-raised-button color="primary" (click)="saveUser()" [disabled]="!dcUserForm.valid">{{'Save' | translate}}</button>
        </div>
      </div>
    </div>
  </form>

</div>
</div>

